// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Artist Dashboard Styles */
.artist-dashboard {
  padding: 2rem 1rem;
  max-width: 100%;
  margin: 0 auto;
}

/* Calendar Section */
.calendar-section {
  position: relative;
  margin-bottom: 3rem;
  min-height: 420px;
}

/* Week view on artist dashboard: min fits one show, grows with content */
.artist-dashboard .calendar-section:has(.week-calendar) {
  min-height: 320px;
}

.calendar-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(12, 12, 14, 0.6);
  backdrop-filter: blur(2px);
  z-index: 5;
  border-radius: 16px;
  pointer-events: all;
}

.calendar-loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  background: rgba(24, 24, 28, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
}

.calendar-loading-spinner {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.15);
  border-top-color: var(--primary-red);
  border-right-color: rgba(255, 255, 255, 0.35);
  animation: calendarSpinner 0.9s linear infinite;
}

.calendar-loading-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

@keyframes calendarSpinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.calendar-nav {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 0;
}

.calendar-nav-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  width: 100%;
}

.calendar-nav-right {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.calendar-month-display {
  color: var(--text-white);
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  flex-shrink: 0;
  min-width: 250px;
}

.nav-btn-group {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.nav-btn {
  padding: 0.75rem 1.5rem;
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  background: var(--bg-card);
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-btn:hover {
  border-color: var(--border-red);
  color: var(--primary-red);
  box-shadow: var(--shadow-red);
}

.week-btn {
  background: var(--bg-gray);
}

.day-btn {
  background: var(--bg-card);
}

/* Week Calendar - Artist Dashboard only (scoped to override bar-owner.css) */
.artist-dashboard .week-calendar {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 0.75rem;
  width: 100%;
  margin: 0;
}

.artist-dashboard .week-calendar .calendar-day {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 0;
  flex: 1;
  min-height: 280px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.artist-dashboard .week-calendar .calendar-day:hover {
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.artist-dashboard .week-calendar .calendar-day.today {
  border-color: var(--primary-red);
  box-shadow: var(--shadow-red);
}

.artist-dashboard .week-calendar .calendar-day.today::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.artist-dashboard .week-calendar .day-header {
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid var(--border-gray);
  background: var(--bg-gray);
}

.artist-dashboard .week-calendar .day-name {
  color: var(--text-gray);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.25rem;
}

.artist-dashboard .week-calendar .day-number {
  color: var(--text-white);
  font-size: 1.5rem;
  font-weight: 700;
}

.artist-dashboard .week-calendar .day-shows {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
  flex: 1;
}

/* Artist Show Cards (Chronological Display) */
.artist-show-card {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.artist-show-card:hover {
  border-color: var(--border-red);
  background: var(--bg-gray-light);
  box-shadow: var(--shadow-red);
  transform: translateY(-2px);
}

.artist-show-card:focus,
.artist-show-card:focus-visible {
  outline: none;
  border-color: var(--border-red);
  box-shadow: 0 0 0 2px rgba(250, 82, 82, 0.25);
}

.artist-show-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-gray);
}

.artist-show-card-time {
  color: var(--text-white);
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.artist-show-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0;
  gap: 0.25rem;
}

.artist-show-card-stage-name {
  color: var(--text-gray);
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
}

.artist-show-card-venue {
  color: var(--text-white);
  font-weight: 600;
  font-size: 0.9rem;
  text-align: center;
}

/* Pending show indicators */
.artist-show-card.pending {
  border-style: dashed;
  opacity: 0.8;
  border-color: rgba(250, 82, 82, 0.5);
}

.artist-show-card.pending:hover {
  opacity: 1;
  border-color: rgba(250, 82, 82, 0.8);
}

.artist-show-card-header .pending-badge {
  margin-left: 0.5rem;
  font-size: 0.7rem;
}

.show-card-modal-venue .pending-badge {
  margin-left: 0.5rem;
  font-size: 0.85rem;
}

.no-shows-message {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  flex: 1;
}

.no-show-text {
  color: var(--text-muted);
  font-size: 0.8rem;
  font-style: italic;
  text-align: center;
}

.blocked-day {
  opacity: 0.7;
  border-color: rgba(250, 82, 82, 0.3);
}

.blocked-day-message {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  flex: 1;
}

.blocked-day-text {
  color: var(--primary-red);
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
  padding: 0.5rem 1rem;
  background: rgba(250, 82, 82, 0.1);
  border: 1px solid rgba(250, 82, 82, 0.3);
  border-radius: 8px;
}

/* Financial Section */
.financial-section {
  margin-top: 3rem;
}

.financial-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0 0.25rem;
}

.financial-section-title {
  color: var(--text-white);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.financial-section-info-icon {
  flex-shrink: 0;
}

.section-title {
  color: var(--text-white);
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.financial-grid {
  display: flex;
  gap: 1.5rem;
  width: 100%;
  margin: 0;
}

.financial-card {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 300px;
}

.financial-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.financial-card:hover {
  transform: translateY(-5px);
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.financial-card h3 {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
}

/* Info icon (?) in top right of average cards – hover shows how numbers are calculated */
.financial-section .info-icon {
  position: relative;
  display: inline-block;
  cursor: help;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  border: 1px solid var(--text-muted);
  color: var(--text-muted);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.1;
  text-align: center;
  flex-shrink: 0;
}

.financial-section .info-icon:hover {
  opacity: 1;
  color: var(--text-white);
  border-color: var(--text-white);
}

.financial-section .card-info-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
}

.financial-section .info-icon[data-tooltip]::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: auto;
  top: 100%;
  left: auto;
  right: 0;
  transform: none;
  margin-top: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.85rem;
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
  white-space: normal;
  width: 280px;
  max-width: 90vw;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  line-height: 1.5;
  text-align: left;
}

.financial-section .info-icon[data-tooltip]:hover::before {
  opacity: 1;
  pointer-events: auto;
}

.financial-section .info-icon[data-tooltip]::after {
  content: "";
  position: absolute;
  bottom: auto;
  top: 100%;
  left: auto;
  right: 1rem;
  transform: none;
  margin-top: 0.25rem;
  border: 6px solid transparent;
  border-top-color: transparent;
  border-bottom-color: var(--border-gray);
  z-index: 1001;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.financial-section .info-icon[data-tooltip]:hover::after {
  opacity: 1;
  pointer-events: auto;
}

.earnings-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: auto;
  flex: 1;
  justify-content: flex-start;
}

.time-slot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-gray);
}

.time-slot:last-child {
  border-bottom: none;
}

.time-slot.total {
  border-top: 2px solid var(--primary-red);
  padding-top: 0.75rem;
  margin-top: 0.5rem;
}

.slot-label {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.slot-amount {
  color: var(--primary-red);
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.time-slot.total .slot-amount {
  font-size: 1.3rem;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

/* Earnings Overview / financial cards: green for earnings */
.financial-section .slot-amount {
  color: #22c55e;
}

.financial-section .time-slot.total .slot-amount {
  color: #22c55e;
  text-shadow: 0 0 10px rgba(34, 197, 94, 0.3);
}

.financial-section .slot-amount .spinner {
  border-top-color: #22c55e;
}

/* Spinner for financial cards */
.slot-amount .spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--border-gray);
  border-top-color: var(--primary-red);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Show Card Modal */
.show-card-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 8, 10, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(6px);
  z-index: 1100;
  padding: 1rem;
}

.show-card-modal {
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  overflow: hidden;
  animation: showCardModalFade 0.25s ease;
  display: flex;
  flex-direction: column;
}

/* Screen reader only - for accessibility */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Show Card Modal - Onboarding-style layout (matches onboarding page) */
.show-card-modal--onboarding-style {
  max-width: 700px;
  border: 2px solid var(--border-gray);
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
}

.show-card-modal--onboarding-style .artist-profile-modal-header {
  border-radius: 16px 16px 0 0;
  border-bottom: 2px solid var(--border-gray);
}

.show-card-modal--onboarding-style .artist-profile-modal-header::before {
  border-radius: 16px 16px 0 0;
}

.show-card-modal-form--onboarding {
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow: hidden;
  flex: 1;
  min-height: 0;
}

.show-card-modal-body--onboarding {
  padding: 2rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  flex: 1;
  min-height: 0;
}

.show-card-modal--onboarding-style .show-card-modal-section {
  background: var(--bg-card);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  padding: 2rem;
  transition: border-color 0.3s ease;
}

.show-card-modal--onboarding-style .show-card-modal-section:hover {
  border-color: var(--border-red);
}

.show-card-modal--onboarding-style .show-card-modal-section .section-title {
  color: var(--text-white);
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.show-card-modal--onboarding-style .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.show-card-modal--onboarding-style .form-grid .input-group {
  min-width: 0;
  overflow: hidden;
}

.show-card-modal--onboarding-style .form-grid .input-group.full-width {
  grid-column: 1 / -1;
}

.show-card-modal-currency-input {
  display: flex;
  align-items: center;
  background: var(--bg-gray-light);
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  overflow: hidden;
  transition: border-color 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}

.show-card-modal-currency-input:focus-within {
  border-color: var(--primary-red);
  outline: none;
}

.show-card-modal-currency-prefix {
  padding: 0.75rem 1rem;
  color: var(--text-gray);
  font-weight: 600;
  font-size: 0.95rem;
  background: rgba(255, 255, 255, 0.03);
  border-right: 2px solid var(--border-gray);
}

.show-card-modal-currency-input .settings-input {
  flex: 1;
  border: none;
  background: transparent;
  border-radius: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.show-card-modal-currency-input .settings-input:focus {
  box-shadow: none;
}

.show-card-modal-currency-hint {
  margin: 0.35rem 0 0;
  font-size: 0.85rem;
  color: var(--text-gray);
  font-weight: 500;
}

.show-card-modal-total-row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.show-card-modal-total-value {
  padding: 0.75rem 1rem;
  background: var(--bg-gray-light);
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: #22c55e;
  font-size: 0.9rem;
  font-weight: 600;
}

.show-card-modal-footer--onboarding {
  padding: 2rem;
  border-top: 2px solid var(--border-gray);
}

.show-card-modal-cancel-btn {
  padding: 0.75rem 2rem;
  background: transparent;
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: var(--text-gray);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.show-card-modal-cancel-btn:hover:enabled {
  border-color: var(--primary-red);
  color: var(--primary-red);
}

.show-card-modal-cancel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.show-card-modal-confirm .section-description {
  margin-bottom: 1rem;
}

.show-card-modal-confirm-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin-top: 1rem;
}

@keyframes showCardModalFade {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.show-card-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
}

.show-card-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
}

.show-card-modal-header-content h2 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--text-white);
  letter-spacing: 0.5px;
}

.show-card-modal-venue {
  margin: 0.4rem 0 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  letter-spacing: 0.4px;
}

.show-card-modal-close {
  border: none;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.6);
  width: 40px;
  height: 40px;
  border-radius: 12px;
  font-size: 1.75rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.show-card-modal-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--primary-red);
}

.show-card-modal-body {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  position: relative;
}

.show-card-modal-body--loading {
  min-height: 280px;
  align-items: center;
  justify-content: center;
}

.show-card-modal-artist {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
}

.show-card-modal-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
}

.show-card-modal-info-item {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.show-card-modal-info-item .label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: rgba(255, 255, 255, 0.55);
}

.show-card-modal-info-item .value {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}

.show-card-modal-statistics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.show-card-modal-stat {
  padding: 1.1rem 1.25rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.show-card-modal-stat--total {
  grid-column: 1 / -1;
  border-color: rgba(250, 82, 82, 0.4);
  background: rgba(250, 82, 82, 0.08);
}

.show-card-modal-stat .label {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 0.4px;
}

.show-card-modal-stat .value {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-white);
}

.show-card-modal-stat--total .value {
  font-size: 1.5rem;
  color: var(--primary-red);
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

.show-card-modal-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.75);
}

.show-card-modal-loading--centered {
  min-height: 160px;
  justify-content: center;
  flex-direction: column;
}

.show-card-modal-loading .spinner {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-top-color: var(--primary-red);
  animation: showCardSpinner 0.75s linear infinite;
}

@keyframes showCardSpinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Groups modal loading state (centered spinner while fetching members) */
.groups-modal-loading.groups-modal-loading--centered {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
  min-height: 160px;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
  font-style: normal;
  font-size: 0.95rem;
}

.groups-modal-loading.groups-modal-loading--centered .spinner {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-top-color: var(--primary-red);
  animation: showCardSpinner 0.75s linear infinite;
}

.show-card-modal-error {
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(250, 82, 82, 0.4);
  color: rgba(255, 155, 155, 0.9);
  background: rgba(250, 82, 82, 0.15);
  font-size: 0.9rem;
}

.show-card-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1.25rem 1.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  gap: 0.75rem;
  background: transparent;
}

.show-card-modal-secondary-btn {
  border: none;
  padding: 0.7rem 1.8rem;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease,
    background-color 0.2s ease;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
}

.show-card-modal-secondary-btn:hover:enabled {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.12);
}

.show-card-modal-secondary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Responsive */
@media (max-width: 1024px) {
  .artist-dashboard .week-calendar {
    gap: 0.5rem;
  }
}

@media (max-width: 768px) {
  .calendar-nav-right {
    display: none;
  }

  .calendar-nav-content {
    gap: 1.5rem;
  }

  .calendar-month-display {
    font-size: 1.2rem;
    min-width: 180px;
  }

  .artist-dashboard .week-calendar {
    flex-direction: column;
  }

  .financial-grid {
    flex-direction: column;
  }

  .show-card-modal-statistics {
    grid-template-columns: 1fr;
  }

  .show-card-modal--onboarding-style .form-grid {
    grid-template-columns: 1fr;
  }

  .onboarding-actions {
    flex-direction: column;
  }

  .onboarding-actions .show-card-modal-cancel-btn,
  .onboarding-actions .submit-btn,
  .onboarding-actions .danger-btn {
    width: 100%;
  }
}

/* Availability Page Styles */
.availability-section {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.weekly-schedule-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.availability-day-card {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.5rem;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.availability-day-card:hover {
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.availability-day-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-gray);
  flex-shrink: 0;
}

.availability-time-inputs {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  width: 100%;
  margin-top: 0.5rem;
  padding: 0;
  box-sizing: border-box;
}

.availability-time-inputs > * {
  box-sizing: border-box;
}

.availability-saving-overlay {
  pointer-events: none;
}

.time-input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;
}

.time-input-group .settings-input {
  width: 100%;
  box-sizing: border-box;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: 0.3s;
  border-radius: 26px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: var(--primary-red);
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}

.block-form {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.blocks-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.block-card {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.25rem;
  transition: all 0.3s ease;
}

.block-card:hover {
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.block-card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.delete-btn:hover {
  background: rgba(250, 82, 82, 0.2) !important;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .weekly-schedule-grid {
    grid-template-columns: 1fr;
  }

  .availability-day-card {
    min-width: 0;
  }

  .availability-time-inputs {
    min-width: 0;
  }

  .time-input-group {
    min-width: 0;
  }

  .time-input-group .settings-input {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    display: block;
    box-sizing: border-box;
    padding: 0.65rem 0.75rem;
    font-size: 16px;
  }

  .availability-time-inputs input[type="time"] {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    -webkit-appearance: none;
    appearance: none;
  }

  .block-card-content {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
}

/* Confirm Modal Styles */
.confirm-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 8, 10, 0.78);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 1.5rem;
}

.confirm-modal {
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  width: 100%;
  max-width: 420px;
  overflow: hidden;
  animation: showCardModalFade 0.2s ease;
  display: flex;
  flex-direction: column;
}

.confirm-modal-header {
  padding: 1.25rem 1.75rem 0.75rem;
}

.confirm-modal-header h3 {
  margin: 0;
  font-size: 1.3rem;
  color: var(--text-white);
}

.confirm-modal-body {
  padding: 0 1.75rem 1.5rem;
}

.confirm-modal-body p {
  margin: 0;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.6;
}

.confirm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.75rem 1.5rem;
}

.confirm-modal-secondary-btn,
.confirm-modal-danger-btn {
  border: none;
  padding: 0.65rem 1.6rem;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.confirm-modal-secondary-btn {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
}

.confirm-modal-secondary-btn:hover:enabled {
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
  transform: translateY(-1px);
}

.confirm-modal-danger-btn {
  background: rgba(250, 82, 82, 0.2);
  color: rgba(255, 155, 155, 0.95);
  border: 1px solid rgba(250, 82, 82, 0.4);
}

.confirm-modal-danger-btn:hover:enabled {
  box-shadow: 0 12px 26px rgba(250, 82, 82, 0.25);
  transform: translateY(-1px);
}

.confirm-modal-danger-btn:disabled,
.confirm-modal-secondary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Leave Bar confirm: formatted show list */
.leave-bar-confirm-modal {
  max-width: 460px;
}

.leave-bar-confirm-modal .confirm-modal-body p {
  margin-bottom: 0.75rem;
}

.leave-bar-confirm-modal .confirm-modal-body p:last-child {
  margin-bottom: 0;
}

.leave-bar-shows-list {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 0.5rem;
  margin-top: 0.5rem;
  background: rgba(0, 0, 0, 0.2);
}

.leave-bar-show-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding: 0.65rem 0.75rem;
  border-radius: 6px;
  margin-bottom: 0.25rem;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
}

.leave-bar-show-item:last-child {
  margin-bottom: 0;
}

.leave-bar-show-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

.leave-bar-show-item strong {
  font-weight: 600;
  color: var(--text-white, #fff);
}

.leave-bar-show-time {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.75);
}

/* Earnings Page Styles */
.earnings-page {
  padding: 2rem 1rem;
  max-width: 100%;
  margin: 0 auto;
}

.earnings-page-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
}

.earnings-page-title {
  color: var(--text-white);
  font-size: 2rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0;
}

.earnings-bar-section {
  margin-top: 3rem;
}

.earnings-bar-section .section-title {
  margin-bottom: 1rem;
  text-align: center;
}

/* Shared column widths so EARNINGS BY BAR and PAST SHOWS align */
.earnings-tables-aligned {
  table-layout: fixed;
  width: 100%;
}

.earnings-tables-aligned .earnings-col-date {
  width: 11%;
}

.earnings-tables-aligned .earnings-col-bar-name {
  width: 22%;
}

.earnings-tables-aligned .earnings-col-base-pay,
.earnings-tables-aligned .earnings-col-cash-tips,
.earnings-tables-aligned .earnings-col-electronic-tips {
  width: 17%;
}

.earnings-tables-aligned .earnings-col-total {
  width: 16%;
}

.earnings-bar-breakdown {
  width: 100%;
  margin-top: 1rem;
}

.earnings-bar-breakdown-container {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  overflow: hidden;
  width: 100%;
}

.earnings-bar-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  background: var(--bg-card);
}

.earnings-bar-table .earnings-bar-col-name {
  width: 28%;
}

.earnings-bar-table .earnings-bar-col-show-count {
  width: 12%;
}

.earnings-bar-table .earnings-bar-col-base-pay,
.earnings-bar-table .earnings-bar-col-cash-tips,
.earnings-bar-table .earnings-bar-col-electronic-tips {
  width: 15%;
}

.earnings-bar-table .earnings-bar-col-total {
  width: 15%;
}

.earnings-bar-table thead {
  background: var(--bg-gray);
  border-bottom: 2px solid var(--border-gray);
}

.earnings-bar-table th {
  padding: 1rem 1.25rem;
  text-align: left;
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-right: 1px solid var(--border-gray);
  white-space: nowrap;
}

.earnings-bar-table th:last-child {
  border-right: none;
}

.earnings-bar-table tbody tr {
  border-bottom: 1px solid var(--border-gray);
  transition: background-color 0.2s ease;
}

.earnings-bar-table tbody tr.even {
  background: var(--bg-card);
}

.earnings-bar-table tbody tr.odd {
  background: var(--bg-gray);
}

.earnings-bar-table tbody tr:hover {
  background: var(--bg-gray-light);
}

.earnings-bar-table tbody tr:last-child {
  border-bottom: none;
}

.earnings-bar-totals-row {
  background: var(--bg-gray-light) !important;
  border-top: 2px solid var(--primary-red);
  border-bottom: 2px solid var(--border-gray);
  font-weight: 600;
}

.earnings-bar-totals-row td {
  color: var(--text-white);
  font-weight: 600;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.earnings-bar-totals-row td:first-child {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--primary-red);
}

.earnings-bar-table td {
  padding: 0.875rem 1.25rem;
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  border-right: 1px solid var(--border-gray);
  white-space: nowrap;
  text-align: left;
}

.earnings-bar-table td:last-child {
  border-right: none;
}

.earnings-bar-table td.earnings-bar-num {
  color: #22c55e;
}

/* # of shows column uses same white as bar names */
.earnings-bar-table td.earnings-bar-show-count {
  color: var(--text-white);
}

.earnings-bar-table td.earnings-bar-total {
  font-weight: 700;
  color: #22c55e;
}

.earnings-bar-breakdown-empty {
  padding: 2rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 1rem;
}

.earnings-bar-breakdown-empty p {
  margin: 0;
}

.earnings-table-section {
  margin-top: 3rem;
}

.earnings-table-header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.earnings-table-header .section-title {
  margin: 0;
}

.earnings-table-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.earnings-table-filter label {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.earnings-table-filter select {
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  border: 1px solid var(--border-gray);
  background: var(--bg-card);
  color: var(--text-white);
  font-size: 0.9rem;
  cursor: pointer;
}

.earnings-table-filter select:focus {
  outline: none;
  border-color: var(--primary-red);
}

/* Excel-like Table Styles */
.earnings-table-container {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  overflow: hidden;
  margin-top: 1.5rem;
}

.earnings-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--bg-card);
}

.earnings-table thead {
  background: var(--bg-gray);
  border-bottom: 2px solid var(--border-gray);
}

.earnings-table th {
  padding: 1rem 1.25rem;
  text-align: left;
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-right: 1px solid var(--border-gray);
  white-space: nowrap;
}

.earnings-table th:last-child {
  border-right: none;
}

.earnings-table tbody tr {
  border-bottom: 1px solid var(--border-gray);
  transition: background-color 0.2s ease;
}

.earnings-table tbody tr.even {
  background: var(--bg-card);
}

.earnings-table tbody tr.odd {
  background: var(--bg-gray);
}

.earnings-table tbody tr:hover {
  background: var(--bg-gray-light);
}

.earnings-table tbody tr.earnings-table-row-clickable {
  cursor: pointer;
}

.earnings-table tbody tr.earnings-table-row-clickable:hover {
  background: var(--bg-gray-light);
}

.earnings-table tbody tr:last-child {
  border-bottom: none;
}

.earnings-table-totals-row {
  background: var(--bg-gray-light) !important;
  border-top: 2px solid var(--primary-red);
  border-bottom: 2px solid var(--border-gray);
  font-weight: 600;
}

.earnings-table-totals-row td {
  color: var(--text-white);
  font-weight: 600;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.earnings-table-totals-row td:first-child {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--primary-red);
}

.earnings-table td {
  padding: 0.875rem 1.25rem;
  color: var(--text-white);
  font-size: 0.95rem;
  border-right: 1px solid var(--border-gray);
  white-space: nowrap;
}

.earnings-table td:last-child {
  border-right: none;
}

.earnings-table-empty {
  padding: 3rem 2rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 1rem;
}

.earnings-table-empty p {
  margin: 0;
}

/* Responsive Table */
@media (max-width: 768px) {
  .earnings-page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .earnings-bar-section {
    min-width: 0;
  }

  .earnings-bar-breakdown-container {
    overflow-x: visible;
    min-width: 0;
  }

  .earnings-table-header {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    gap: 0.75rem;
  }

  .earnings-table-filter {
    justify-content: center;
    flex-wrap: wrap;
  }

  .earnings-table-section {
    min-width: 0;
  }

  .earnings-table-container {
    overflow-x: visible;
    min-width: 0;
  }

  /* Stacked “card” rows for earnings tables (avoids 6-column squeeze / overlap) */
  .earnings-bar-table thead,
  .earnings-table thead {
    display: none;
  }

  .earnings-bar-table colgroup,
  .earnings-table colgroup {
    display: none;
  }

  .earnings-bar-table,
  .earnings-table {
    display: block;
    width: 100%;
    table-layout: auto;
  }

  .earnings-bar-table tbody,
  .earnings-table tbody {
    display: block;
  }

  .earnings-bar-table tbody tr,
  .earnings-table tbody tr {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.75rem;
    padding: 0.75rem 1rem;
    border: 1px solid var(--border-gray);
    border-radius: 12px;
    background: var(--bg-card);
    box-sizing: border-box;
  }

  .earnings-bar-table tbody tr:last-child,
  .earnings-table tbody tr:last-child {
    margin-bottom: 0;
  }

  .earnings-bar-table tbody tr.even {
    background: var(--bg-card);
  }

  .earnings-bar-table tbody tr.odd {
    background: rgba(255, 255, 255, 0.03);
  }

  .earnings-bar-table tbody tr:hover,
  .earnings-table tbody tr:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  .earnings-bar-totals-row,
  .earnings-table-totals-row {
    border: 2px solid var(--primary-red);
    background: var(--bg-gray-light) !important;
  }

  .earnings-bar-table td,
  .earnings-table td {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.75rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0.5rem 0;
    border: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    white-space: normal;
    text-align: right;
    font-size: 0.9rem;
  }

  .earnings-bar-table td:last-child,
  .earnings-table td:last-child {
    border-bottom: none;
  }

  .earnings-bar-table td[data-label]::before,
  .earnings-table td[data-label]::before {
    content: attr(data-label);
    flex-shrink: 0;
    max-width: 48%;
    font-weight: 600;
    font-size: 0.75rem;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    text-align: left;
    line-height: 1.3;
  }

  .earnings-bar-table td.earnings-bar-mobile-summary-heading,
  .earnings-table td.earnings-table-mobile-summary-heading {
    display: block;
    text-align: left;
    font-weight: 700;
    font-size: 0.95rem;
    color: var(--primary-red);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    padding: 0 0 0.5rem 0;
    margin-bottom: 0.25rem;
    border-bottom: 2px solid var(--primary-red);
  }

  .earnings-table tbody tr.earnings-table-row-clickable {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .earnings-table tbody tr.earnings-table-row-clickable:focus-visible {
    outline: 2px solid var(--primary-red);
    outline-offset: 2px;
  }
}

/* Groups Page Styles */
.groups-page {
  padding: 2rem 1rem;
  max-width: 100%;
  margin: 0 auto;
}

.groups-section {
  margin-bottom: 4rem;
}

.groups-section:last-child {
  margin-bottom: 0;
}

.groups-section .section-title {
  color: var(--text-white);
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.groups-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 300px;
}

.groups-loading .spinner {
  width: 3rem;
  height: 3rem;
  border: 3px solid var(--border-gray);
  border-top-color: var(--primary-red);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 1rem;
}

.groups-loading p {
  color: var(--text-gray);
  font-size: 1rem;
}

.groups-error {
  text-align: center;
  padding: 2rem;
  color: var(--primary-red);
  background: rgba(250, 82, 82, 0.1);
  border: 1px solid rgba(250, 82, 82, 0.3);
  border-radius: 12px;
}

.groups-error p {
  margin: 0;
  font-size: 1rem;
}

/* Bars Grid - Similar to Artists Grid */
.bars-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  padding-bottom: 2rem;
}

.bar-card {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.bar-card:hover {
  transform: translateY(-4px);
  border-color: var(--primary-red);
  box-shadow: 0 8px 25px rgba(220, 38, 38, 0.2);
}

.bar-photo {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: var(--bg-gray-light);
}

.bar-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.bar-card:hover .bar-photo img {
  transform: scale(1.05);
}

.bar-info {
  padding: 1.5rem;
}

.bar-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-white);
  margin-bottom: 0.5rem;
}

.bar-address {
  color: var(--text-gray);
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

/* Bar Modal Styles */
.bar-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 8, 10, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(6px);
  z-index: 1100;
  padding: 1.5rem;
}

.bar-modal {
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  overflow: hidden;
  animation: showCardModalFade 0.25s ease;
  display: flex;
  flex-direction: column;
}

.bar-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
}

.bar-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
}

.bar-modal-header-content h2 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--text-white);
  letter-spacing: 0.5px;
}

.bar-modal-address {
  margin: 0.4rem 0 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  letter-spacing: 0.4px;
}

.bar-modal-close {
  border: none;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.6);
  width: 40px;
  height: 40px;
  border-radius: 12px;
  font-size: 1.75rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.bar-modal-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--primary-red);
}

.bar-modal-body {
  padding: 1.75rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Bar Modal: match Edit modal section styling (onboarding-section) */
.bar-modal-body .onboarding-section .section-title {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bar-modal-body .form-grid {
  min-width: 0;
}

.bar-modal-body .form-grid .input-group {
  min-width: 0;
}

.bar-modal-map-toggle {
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bar-modal-map-toggle:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--primary-red);
  color: var(--text-white);
}

.bar-modal-leave-btn {
  padding: 0.5rem 1rem;
  background: rgba(255, 0, 51, 0.1);
  border: 1px solid var(--primary-red);
  border-radius: 6px;
  color: var(--primary-red);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bar-modal-leave-btn:hover:not(:disabled) {
  background: rgba(255, 0, 51, 0.2);
  border-color: var(--primary-red-glow);
  color: var(--primary-red-glow);
}

.bar-modal-leave-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bar-modal-artist-selector-overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 8, 10, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.bar-modal-artist-selector {
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.bar-modal-artist-selector h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--text-white);
}

.bar-modal-artist-selector p {
  margin: 0 0 1.5rem 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
}

.bar-modal-artist-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.bar-modal-artist-option {
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.bar-modal-artist-option:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--primary-red);
}

.bar-modal-artist-selector-cancel {
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bar-modal-artist-selector-cancel:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--text-white);
}

.bar-modal-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.bar-modal-section-title {
  color: var(--text-white);
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

.bar-modal-photos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
}

.bar-modal-photo {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid var(--border-gray);
  transition: transform 0.3s ease;
}

.bar-modal-photo:hover {
  transform: scale(1.05);
  border-color: var(--primary-red);
}

.bar-modal-info-item {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.bar-modal-label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: rgba(255, 255, 255, 0.55);
}

.bar-modal-value {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}

.bar-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1.25rem 1.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  gap: 0.75rem;
  background: transparent;
}

.bar-modal-close-btn {
  border: none;
  padding: 0.7rem 1.8rem;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease,
    background-color 0.2s ease;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
}

.bar-modal-close-btn:hover:enabled {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.12);
}

/* Responsive Groups Page */
@media (max-width: 768px) {
  .groups-page {
    padding: 1rem 0.5rem;
  }

  .groups-section .section-title {
    font-size: 1.5rem;
  }

  .artists-grid,
  .bars-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .bar-modal {
    max-width: 95vw;
    max-height: 95vh;
  }

  .bar-modal-photos {
    grid-template-columns: 1fr;
  }
}

/* Bulletin Board - Coming Soon */
.bulletin-board-page {
  padding: 2rem 1rem;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.coming-soon-container {
  text-align: center;
  padding: 3rem 2rem;
}

.coming-soon-icon {
  font-size: 3rem;
  display: block;
  margin-bottom: 1rem;
}

.coming-soon-container h2 {
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
  color: var(--text-primary, #fff);
}

.coming-soon-message {
  color: var(--text-secondary, rgba(255, 255, 255, 0.7));
  font-size: 1rem;
}

/* Genre multi-select (onboarding + artist modals) */
.genre-multiselect {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

.genre-multiselect-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  min-height: 1.5rem;
}

.genre-multiselect-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  font-size: 0.85rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: var(--text-primary, #fff);
}

.genre-multiselect-chip-remove {
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
  padding: 0 0.15rem;
}

.genre-multiselect-chip-remove:hover:not(:disabled) {
  color: #fff;
}

.genre-multiselect-chip-remove:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.genre-multiselect-hint {
  margin: 0;
  font-size: 0.8rem;
  opacity: 0.85;
}

/* Display-only genre pills (profile modals, cards) */
.artist-genre-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.artist-genre-pill {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.8rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

/* Groups page: centered title + primary action without duplicate invisible buttons */
.groups-page-header {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 2rem;
}

.groups-page-header__action {
  grid-column: 1;
  justify-self: start;
}

.groups-page-header__title {
  grid-column: 2;
  margin: 0;
  text-align: center;
}

/* Artist month calendar — day-detail list (desktop + mobile) */
.artist-day-detail-modal-content {
  max-height: min(60vh, 28rem);
  overflow-y: auto;
}

.artist-day-detail-empty {
  margin: 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.95rem;
}

.artist-day-detail-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.artist-day-detail-item {
  margin: 0;
}

.artist-day-detail-show-row {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.75rem;
  text-align: left;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  border: 1px solid var(--border-gray);
  background: var(--bg-gray);
  color: var(--text-white);
  font-size: 0.9rem;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.artist-day-detail-show-row:hover {
  border-color: var(--primary-red);
  box-shadow: var(--shadow-red);
}

.artist-day-detail-show-time {
  font-weight: 600;
  flex: 1 1 auto;
  min-width: 0;
}

.artist-day-detail-show-venue {
  flex: 1 1 100%;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
}

.artist-day-detail-pending {
  margin-left: auto;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 210, 120, 1);
}

@media (max-width: 768px) {
  /* Groups header: stack title above full-width button */
  .groups-page-header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .groups-page-header__title {
    order: -1;
    text-align: center;
  }

  .groups-page-header__action {
    width: 100%;
    justify-self: stretch;
  }

  /*
   * Artist calendar nav (both week dashboard and full-month Calendar): compact column-stacked nav on mobile.
   * Mirrors .bar-owner-dashboard calendar mobile behavior without affecting bar-owner desktop CSS files.
   */
  .artist-dashboard .calendar-section .calendar-nav {
    gap: 1rem;
    flex-direction: column;
  }

  .artist-dashboard .calendar-section .calendar-nav-content {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    gap: 0.65rem 0.75rem;
  }

  .artist-dashboard .calendar-section .calendar-month-display {
    order: -1;
    flex: 1 1 100%;
    min-width: 0;
    width: 100%;
    letter-spacing: 0.12em;
    margin: 0;
    font-size: 1.15rem;
    text-align: center;
  }

  .artist-dashboard .calendar-section .calendar-nav-content > .nav-btn-group {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0.35rem;
    justify-content: center;
    align-items: center;
  }

  .artist-dashboard .calendar-section .calendar-nav-content .nav-btn {
    padding: 0.55rem 0.45rem;
    font-size: 0.72rem;
    letter-spacing: 0.03em;
    flex: 1 1 auto;
    min-width: 0;
    text-transform: uppercase;
  }

  .artist-dashboard .calendar-section .calendar-nav-content .nav-btn.month-btn {
    flex: 1 1 auto;
    padding: 0.55rem 0.85rem;
    font-size: 0.78rem;
  }

  .artist-dashboard .month-calendar {
    gap: 0.35rem;
  }

  .artist-dashboard .calendar-day-cell {
    min-height: 3.35rem;
    padding: 0.35rem 0.28rem;
    justify-content: flex-start;
    cursor: pointer;
  }

  .artist-dashboard .calendar-day-cell.other-month {
    cursor: default;
  }

  .artist-dashboard .calendar-day-cell .day-header {
    margin-bottom: 0;
  }

  .artist-dashboard .calendar-day-cell .day-number {
    font-size: 0.85rem;
  }

  .artist-dashboard .calendar-day-cell .day-shows {
    display: none;
  }

  .artist-dashboard .calendar-day-mobile-summary {
    display: flex;
    margin-top: 0.2rem;
  }

  .artist-dashboard .calendar-day-cell[role="button"]:focus-visible {
    outline: 2px solid var(--primary-red);
    outline-offset: 2px;
  }

  .artist-dashboard .calendar-day-show-count {
    font-size: 0.68rem;
  }

  /* Artist Calendar day-detail modal: mirror bar-owner mobile sizing & spacing.
     Selectors target the modal's own classes since the modal is rendered outside
     the .artist-dashboard wrapper in Calendar.js. */
  /* Cap width only — modals-mobile.css pins .modal-container with left/right + width:auto;
     a fixed width here fights that and can widen the scrollable document on mobile. */
  .modal-container.calendar-day-detail-modal {
    max-height: 80vh;
    max-height: 80dvh;
    max-width: min(640px, calc(100vw - max(24px, env(safe-area-inset-left) + env(safe-area-inset-right))));
  }

  .calendar-day-detail-modal .modal-content,
  .calendar-day-detail-modal .artist-day-detail-modal-content {
    margin: 0 auto;
    width: 100%;
    max-width: 640px;
    align-items: center;
    padding: 1.5rem;
    gap: 1rem;
  }

  .calendar-day-detail-modal .artist-day-detail-list {
    width: 100%;
    max-width: 560px;
  }

  .calendar-day-detail-modal .artist-day-detail-show-row {
    width: 100%;
  }

  /* Settings: avoid horizontal clip inside tab panels */
  .artist-dashboard .tab-content {
    min-width: 0;
  }

  /* Onboarding: comfortable horizontal padding on phones */
  .onboarding-page .onboarding-container {
    padding-left: 1rem;
    padding-right: 1rem;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./client/styles/artist.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;EACpC,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,UAAU;EACV,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,OAAO;AACT;;AAEA,8CAA8C;AAC9C;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yFAAyF;AACzF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;EACvC,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,4DAA4D;AAC5D;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;EAChB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,+CAA+C;EAC/C,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;8BAC4B;EAC5B,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;AACF;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;8BAC4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA,gFAAgF;EAChF;;IAEE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,oCAAoC;IACpC,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,oCAAoC;IACpC,2CAA2C;EAC7C;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,kDAAkD;IAClD,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,2CAA2C;EAC7C;;EAEA;IACE,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qEAAqE;AACrE;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,+CAA+C;EAC/C,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;8BAC4B;EAC5B,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,sDAAsD;EACtD,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA,qFAAqF;AACrF;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf;;wBAEsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,uDAAuD;EACvD;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;;;IAGE;EACF;IACE,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;oDAEkD;EAClD;sFACoF;EACpF;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sGAAsG;EACxG;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA,sDAAsD;EACtD;IACE,YAAY;EACd;;EAEA,yDAAyD;EACzD;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;EACxB;AACF","sourcesContent":["/* Artist Dashboard Styles */\n.artist-dashboard {\n  padding: 2rem 1rem;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n/* Calendar Section */\n.calendar-section {\n  position: relative;\n  margin-bottom: 3rem;\n  min-height: 420px;\n}\n\n/* Week view on artist dashboard: min fits one show, grows with content */\n.artist-dashboard .calendar-section:has(.week-calendar) {\n  min-height: 320px;\n}\n\n.calendar-loading-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(12, 12, 14, 0.6);\n  backdrop-filter: blur(2px);\n  z-index: 5;\n  border-radius: 16px;\n  pointer-events: all;\n}\n\n.calendar-loading-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  background: rgba(24, 24, 28, 0.75);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);\n}\n\n.calendar-loading-spinner {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  border: 3px solid rgba(255, 255, 255, 0.15);\n  border-top-color: var(--primary-red);\n  border-right-color: rgba(255, 255, 255, 0.35);\n  animation: calendarSpinner 0.9s linear infinite;\n}\n\n.calendar-loading-text {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n@keyframes calendarSpinner {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.calendar-nav {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding: 0;\n}\n\n.calendar-nav-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n  width: 100%;\n}\n\n.calendar-nav-right {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.calendar-month-display {\n  color: var(--text-white);\n  font-size: 1.5rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  text-align: center;\n  flex-shrink: 0;\n  min-width: 250px;\n}\n\n.nav-btn-group {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.nav-btn {\n  padding: 0.75rem 1.5rem;\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  background: var(--bg-card);\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.nav-btn:hover {\n  border-color: var(--border-red);\n  color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.week-btn {\n  background: var(--bg-gray);\n}\n\n.day-btn {\n  background: var(--bg-card);\n}\n\n/* Week Calendar - Artist Dashboard only (scoped to override bar-owner.css) */\n.artist-dashboard .week-calendar {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  gap: 0.75rem;\n  width: 100%;\n  margin: 0;\n}\n\n.artist-dashboard .week-calendar .calendar-day {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 0;\n  flex: 1;\n  min-height: 280px;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.artist-dashboard .week-calendar .calendar-day:hover {\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.artist-dashboard .week-calendar .calendar-day.today {\n  border-color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.artist-dashboard .week-calendar .calendar-day.today::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.artist-dashboard .week-calendar .day-header {\n  padding: 1rem;\n  text-align: center;\n  border-bottom: 1px solid var(--border-gray);\n  background: var(--bg-gray);\n}\n\n.artist-dashboard .week-calendar .day-name {\n  color: var(--text-gray);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 0.25rem;\n}\n\n.artist-dashboard .week-calendar .day-number {\n  color: var(--text-white);\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.artist-dashboard .week-calendar .day-shows {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  flex: 1;\n}\n\n/* Artist Show Cards (Chronological Display) */\n.artist-show-card {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  padding: 0.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.artist-show-card:hover {\n  border-color: var(--border-red);\n  background: var(--bg-gray-light);\n  box-shadow: var(--shadow-red);\n  transform: translateY(-2px);\n}\n\n.artist-show-card:focus,\n.artist-show-card:focus-visible {\n  outline: none;\n  border-color: var(--border-red);\n  box-shadow: 0 0 0 2px rgba(250, 82, 82, 0.25);\n}\n\n.artist-show-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.artist-show-card-time {\n  color: var(--text-white);\n  font-size: 0.85rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.artist-show-card-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 0;\n  gap: 0.25rem;\n}\n\n.artist-show-card-stage-name {\n  color: var(--text-gray);\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n.artist-show-card-venue {\n  color: var(--text-white);\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n/* Pending show indicators */\n.artist-show-card.pending {\n  border-style: dashed;\n  opacity: 0.8;\n  border-color: rgba(250, 82, 82, 0.5);\n}\n\n.artist-show-card.pending:hover {\n  opacity: 1;\n  border-color: rgba(250, 82, 82, 0.8);\n}\n\n.artist-show-card-header .pending-badge {\n  margin-left: 0.5rem;\n  font-size: 0.7rem;\n}\n\n.show-card-modal-venue .pending-badge {\n  margin-left: 0.5rem;\n  font-size: 0.85rem;\n}\n\n.no-shows-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  flex: 1;\n}\n\n.no-show-text {\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  font-style: italic;\n  text-align: center;\n}\n\n.blocked-day {\n  opacity: 0.7;\n  border-color: rgba(250, 82, 82, 0.3);\n}\n\n.blocked-day-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  flex: 1;\n}\n\n.blocked-day-text {\n  color: var(--primary-red);\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-align: center;\n  padding: 0.5rem 1rem;\n  background: rgba(250, 82, 82, 0.1);\n  border: 1px solid rgba(250, 82, 82, 0.3);\n  border-radius: 8px;\n}\n\n/* Financial Section */\n.financial-section {\n  margin-top: 3rem;\n}\n\n.financial-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  padding: 0 0.25rem;\n}\n\n.financial-section-title {\n  color: var(--text-white);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.financial-section-info-icon {\n  flex-shrink: 0;\n}\n\n.section-title {\n  color: var(--text-white);\n  font-size: 2rem;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 2rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.financial-grid {\n  display: flex;\n  gap: 1.5rem;\n  width: 100%;\n  margin: 0;\n}\n\n.financial-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 2rem;\n  text-align: center;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 300px;\n}\n\n.financial-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.financial-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.financial-card h3 {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  line-height: 1.2;\n}\n\n/* Info icon (?) in top right of average cards – hover shows how numbers are calculated */\n.financial-section .info-icon {\n  position: relative;\n  display: inline-block;\n  cursor: help;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n  width: 1.25rem;\n  height: 1.25rem;\n  border-radius: 50%;\n  border: 1px solid var(--text-muted);\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.1;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.financial-section .info-icon:hover {\n  opacity: 1;\n  color: var(--text-white);\n  border-color: var(--text-white);\n}\n\n.financial-section .card-info-icon {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n}\n\n.financial-section .info-icon[data-tooltip]::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: auto;\n  top: 100%;\n  left: auto;\n  right: 0;\n  transform: none;\n  margin-top: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.85rem;\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: normal;\n  white-space: normal;\n  width: 280px;\n  max-width: 90vw;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n  line-height: 1.5;\n  text-align: left;\n}\n\n.financial-section .info-icon[data-tooltip]:hover::before {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.financial-section .info-icon[data-tooltip]::after {\n  content: \"\";\n  position: absolute;\n  bottom: auto;\n  top: 100%;\n  left: auto;\n  right: 1rem;\n  transform: none;\n  margin-top: 0.25rem;\n  border: 6px solid transparent;\n  border-top-color: transparent;\n  border-bottom-color: var(--border-gray);\n  z-index: 1001;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.financial-section .info-icon[data-tooltip]:hover::after {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.earnings-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: auto;\n  flex: 1;\n  justify-content: flex-start;\n}\n\n.time-slot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.time-slot:last-child {\n  border-bottom: none;\n}\n\n.time-slot.total {\n  border-top: 2px solid var(--primary-red);\n  padding-top: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.slot-label {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.slot-amount {\n  color: var(--primary-red);\n  font-size: 1.1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.time-slot.total .slot-amount {\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n/* Earnings Overview / financial cards: green for earnings */\n.financial-section .slot-amount {\n  color: #22c55e;\n}\n\n.financial-section .time-slot.total .slot-amount {\n  color: #22c55e;\n  text-shadow: 0 0 10px rgba(34, 197, 94, 0.3);\n}\n\n.financial-section .slot-amount .spinner {\n  border-top-color: #22c55e;\n}\n\n/* Spinner for financial cards */\n.slot-amount .spinner {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid var(--border-gray);\n  border-top-color: var(--primary-red);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  display: inline-block;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Show Card Modal */\n.show-card-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 8, 10, 0.82);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(6px);\n  z-index: 1100;\n  padding: 1rem;\n}\n\n.show-card-modal {\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  background: var(--bg-card);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n  overflow: hidden;\n  animation: showCardModalFade 0.25s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Screen reader only - for accessibility */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n/* Show Card Modal - Onboarding-style layout (matches onboarding page) */\n.show-card-modal--onboarding-style {\n  max-width: 700px;\n  border: 2px solid var(--border-gray);\n  border-radius: 16px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n}\n\n.show-card-modal--onboarding-style .artist-profile-modal-header {\n  border-radius: 16px 16px 0 0;\n  border-bottom: 2px solid var(--border-gray);\n}\n\n.show-card-modal--onboarding-style .artist-profile-modal-header::before {\n  border-radius: 16px 16px 0 0;\n}\n\n.show-card-modal-form--onboarding {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  overflow: hidden;\n  flex: 1;\n  min-height: 0;\n}\n\n.show-card-modal-body--onboarding {\n  padding: 2rem;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  flex: 1;\n  min-height: 0;\n}\n\n.show-card-modal--onboarding-style .show-card-modal-section {\n  background: var(--bg-card);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 2rem;\n  transition: border-color 0.3s ease;\n}\n\n.show-card-modal--onboarding-style .show-card-modal-section:hover {\n  border-color: var(--border-red);\n}\n\n.show-card-modal--onboarding-style .show-card-modal-section .section-title {\n  color: var(--text-white);\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.show-card-modal--onboarding-style .form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.show-card-modal--onboarding-style .form-grid .input-group {\n  min-width: 0;\n  overflow: hidden;\n}\n\n.show-card-modal--onboarding-style .form-grid .input-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.show-card-modal-currency-input {\n  display: flex;\n  align-items: center;\n  background: var(--bg-gray-light);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  overflow: hidden;\n  transition: border-color 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.show-card-modal-currency-input:focus-within {\n  border-color: var(--primary-red);\n  outline: none;\n}\n\n.show-card-modal-currency-prefix {\n  padding: 0.75rem 1rem;\n  color: var(--text-gray);\n  font-weight: 600;\n  font-size: 0.95rem;\n  background: rgba(255, 255, 255, 0.03);\n  border-right: 2px solid var(--border-gray);\n}\n\n.show-card-modal-currency-input .settings-input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  border-radius: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.show-card-modal-currency-input .settings-input:focus {\n  box-shadow: none;\n}\n\n.show-card-modal-currency-hint {\n  margin: 0.35rem 0 0;\n  font-size: 0.85rem;\n  color: var(--text-gray);\n  font-weight: 500;\n}\n\n.show-card-modal-total-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.show-card-modal-total-value {\n  padding: 0.75rem 1rem;\n  background: var(--bg-gray-light);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: #22c55e;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.show-card-modal-footer--onboarding {\n  padding: 2rem;\n  border-top: 2px solid var(--border-gray);\n}\n\n.show-card-modal-cancel-btn {\n  padding: 0.75rem 2rem;\n  background: transparent;\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: var(--text-gray);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.show-card-modal-cancel-btn:hover:enabled {\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n}\n\n.show-card-modal-cancel-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.show-card-modal-confirm .section-description {\n  margin-bottom: 1rem;\n}\n\n.show-card-modal-confirm-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n@keyframes showCardModalFade {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.show-card-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.75rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: relative;\n}\n\n.show-card-modal-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n}\n\n.show-card-modal-header-content h2 {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--text-white);\n  letter-spacing: 0.5px;\n}\n\n.show-card-modal-venue {\n  margin: 0.4rem 0 0;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.95rem;\n  letter-spacing: 0.4px;\n}\n\n.show-card-modal-close {\n  border: none;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.6);\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  font-size: 1.75rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.show-card-modal-close:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--primary-red);\n}\n\n.show-card-modal-body {\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n  position: relative;\n}\n\n.show-card-modal-body--loading {\n  min-height: 280px;\n  align-items: center;\n  justify-content: center;\n}\n\n.show-card-modal-artist {\n  display: flex;\n  gap: 1.5rem;\n  align-items: flex-start;\n}\n\n.show-card-modal-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  flex: 1;\n}\n\n.show-card-modal-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.show-card-modal-info-item .label {\n  display: block;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.show-card-modal-info-item .value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.show-card-modal-statistics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.show-card-modal-stat {\n  padding: 1.1rem 1.25rem;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.show-card-modal-stat--total {\n  grid-column: 1 / -1;\n  border-color: rgba(250, 82, 82, 0.4);\n  background: rgba(250, 82, 82, 0.08);\n}\n\n.show-card-modal-stat .label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.6);\n  letter-spacing: 0.4px;\n}\n\n.show-card-modal-stat .value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-white);\n}\n\n.show-card-modal-stat--total .value {\n  font-size: 1.5rem;\n  color: var(--primary-red);\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n.show-card-modal-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.04);\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.show-card-modal-loading--centered {\n  min-height: 160px;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.show-card-modal-loading .spinner {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-top-color: var(--primary-red);\n  animation: showCardSpinner 0.75s linear infinite;\n}\n\n@keyframes showCardSpinner {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Groups modal loading state (centered spinner while fetching members) */\n.groups-modal-loading.groups-modal-loading--centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 0.75rem;\n  min-height: 160px;\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.04);\n  color: rgba(255, 255, 255, 0.75);\n  margin: 0;\n  font-style: normal;\n  font-size: 0.95rem;\n}\n\n.groups-modal-loading.groups-modal-loading--centered .spinner {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-top-color: var(--primary-red);\n  animation: showCardSpinner 0.75s linear infinite;\n}\n\n.show-card-modal-error {\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba(250, 82, 82, 0.4);\n  color: rgba(255, 155, 155, 0.9);\n  background: rgba(250, 82, 82, 0.15);\n  font-size: 0.9rem;\n}\n\n.show-card-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1.25rem 1.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  gap: 0.75rem;\n  background: transparent;\n}\n\n.show-card-modal-secondary-btn {\n  border: none;\n  padding: 0.7rem 1.8rem;\n  border-radius: 999px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: box-shadow 0.2s ease, transform 0.2s ease,\n    background-color 0.2s ease;\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.show-card-modal-secondary-btn:hover:enabled {\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);\n  transform: translateY(-1px);\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.show-card-modal-secondary-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .artist-dashboard .week-calendar {\n    gap: 0.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .calendar-nav-right {\n    display: none;\n  }\n\n  .calendar-nav-content {\n    gap: 1.5rem;\n  }\n\n  .calendar-month-display {\n    font-size: 1.2rem;\n    min-width: 180px;\n  }\n\n  .artist-dashboard .week-calendar {\n    flex-direction: column;\n  }\n\n  .financial-grid {\n    flex-direction: column;\n  }\n\n  .show-card-modal-statistics {\n    grid-template-columns: 1fr;\n  }\n\n  .show-card-modal--onboarding-style .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .onboarding-actions {\n    flex-direction: column;\n  }\n\n  .onboarding-actions .show-card-modal-cancel-btn,\n  .onboarding-actions .submit-btn,\n  .onboarding-actions .danger-btn {\n    width: 100%;\n  }\n}\n\n/* Availability Page Styles */\n.availability-section {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.weekly-schedule-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.availability-day-card {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.5rem;\n  position: relative;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.availability-day-card:hover {\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.availability-day-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--border-gray);\n  flex-shrink: 0;\n}\n\n.availability-time-inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n  width: 100%;\n  margin-top: 0.5rem;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.availability-time-inputs > * {\n  box-sizing: border-box;\n}\n\n.availability-saving-overlay {\n  pointer-events: none;\n}\n\n.time-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.time-input-group .settings-input {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.1);\n  transition: 0.3s;\n  border-radius: 26px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.toggle-switch input:checked + .toggle-slider {\n  background-color: var(--primary-red);\n}\n\n.toggle-switch input:checked + .toggle-slider:before {\n  transform: translateX(24px);\n}\n\n.block-form {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.blocks-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.block-card {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.25rem;\n  transition: all 0.3s ease;\n}\n\n.block-card:hover {\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.block-card-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delete-btn:hover {\n  background: rgba(250, 82, 82, 0.2) !important;\n  transform: translateY(-1px);\n}\n\n@media (max-width: 768px) {\n  .weekly-schedule-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .availability-day-card {\n    min-width: 0;\n  }\n\n  .availability-time-inputs {\n    min-width: 0;\n  }\n\n  .time-input-group {\n    min-width: 0;\n  }\n\n  .time-input-group .settings-input {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    display: block;\n    box-sizing: border-box;\n    padding: 0.65rem 0.75rem;\n    font-size: 16px;\n  }\n\n  .availability-time-inputs input[type=\"time\"] {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    -webkit-appearance: none;\n    appearance: none;\n  }\n\n  .block-card-content {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n}\n\n/* Confirm Modal Styles */\n.confirm-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 8, 10, 0.78);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1200;\n  padding: 1.5rem;\n}\n\n.confirm-modal {\n  background: var(--bg-card);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 18px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n  width: 100%;\n  max-width: 420px;\n  overflow: hidden;\n  animation: showCardModalFade 0.2s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.confirm-modal-header {\n  padding: 1.25rem 1.75rem 0.75rem;\n}\n\n.confirm-modal-header h3 {\n  margin: 0;\n  font-size: 1.3rem;\n  color: var(--text-white);\n}\n\n.confirm-modal-body {\n  padding: 0 1.75rem 1.5rem;\n}\n\n.confirm-modal-body p {\n  margin: 0;\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.82);\n  line-height: 1.6;\n}\n\n.confirm-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem 1.75rem 1.5rem;\n}\n\n.confirm-modal-secondary-btn,\n.confirm-modal-danger-btn {\n  border: none;\n  padding: 0.65rem 1.6rem;\n  border-radius: 999px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.confirm-modal-secondary-btn {\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.confirm-modal-secondary-btn:hover:enabled {\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);\n  transform: translateY(-1px);\n}\n\n.confirm-modal-danger-btn {\n  background: rgba(250, 82, 82, 0.2);\n  color: rgba(255, 155, 155, 0.95);\n  border: 1px solid rgba(250, 82, 82, 0.4);\n}\n\n.confirm-modal-danger-btn:hover:enabled {\n  box-shadow: 0 12px 26px rgba(250, 82, 82, 0.25);\n  transform: translateY(-1px);\n}\n\n.confirm-modal-danger-btn:disabled,\n.confirm-modal-secondary-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* Leave Bar confirm: formatted show list */\n.leave-bar-confirm-modal {\n  max-width: 460px;\n}\n\n.leave-bar-confirm-modal .confirm-modal-body p {\n  margin-bottom: 0.75rem;\n}\n\n.leave-bar-confirm-modal .confirm-modal-body p:last-child {\n  margin-bottom: 0;\n}\n\n.leave-bar-shows-list {\n  max-height: 280px;\n  overflow-y: auto;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  padding: 0.5rem;\n  margin-top: 0.5rem;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.leave-bar-show-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  padding: 0.65rem 0.75rem;\n  border-radius: 6px;\n  margin-bottom: 0.25rem;\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.leave-bar-show-item:last-child {\n  margin-bottom: 0;\n}\n\n.leave-bar-show-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.leave-bar-show-item strong {\n  font-weight: 600;\n  color: var(--text-white, #fff);\n}\n\n.leave-bar-show-time {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n/* Earnings Page Styles */\n.earnings-page {\n  padding: 2rem 1rem;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.earnings-page-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.earnings-page-title {\n  color: var(--text-white);\n  font-size: 2rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin: 0;\n}\n\n.earnings-bar-section {\n  margin-top: 3rem;\n}\n\n.earnings-bar-section .section-title {\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n/* Shared column widths so EARNINGS BY BAR and PAST SHOWS align */\n.earnings-tables-aligned {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.earnings-tables-aligned .earnings-col-date {\n  width: 11%;\n}\n\n.earnings-tables-aligned .earnings-col-bar-name {\n  width: 22%;\n}\n\n.earnings-tables-aligned .earnings-col-base-pay,\n.earnings-tables-aligned .earnings-col-cash-tips,\n.earnings-tables-aligned .earnings-col-electronic-tips {\n  width: 17%;\n}\n\n.earnings-tables-aligned .earnings-col-total {\n  width: 16%;\n}\n\n.earnings-bar-breakdown {\n  width: 100%;\n  margin-top: 1rem;\n}\n\n.earnings-bar-breakdown-container {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.earnings-bar-table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  background: var(--bg-card);\n}\n\n.earnings-bar-table .earnings-bar-col-name {\n  width: 28%;\n}\n\n.earnings-bar-table .earnings-bar-col-show-count {\n  width: 12%;\n}\n\n.earnings-bar-table .earnings-bar-col-base-pay,\n.earnings-bar-table .earnings-bar-col-cash-tips,\n.earnings-bar-table .earnings-bar-col-electronic-tips {\n  width: 15%;\n}\n\n.earnings-bar-table .earnings-bar-col-total {\n  width: 15%;\n}\n\n.earnings-bar-table thead {\n  background: var(--bg-gray);\n  border-bottom: 2px solid var(--border-gray);\n}\n\n.earnings-bar-table th {\n  padding: 1rem 1.25rem;\n  text-align: left;\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-right: 1px solid var(--border-gray);\n  white-space: nowrap;\n}\n\n.earnings-bar-table th:last-child {\n  border-right: none;\n}\n\n.earnings-bar-table tbody tr {\n  border-bottom: 1px solid var(--border-gray);\n  transition: background-color 0.2s ease;\n}\n\n.earnings-bar-table tbody tr.even {\n  background: var(--bg-card);\n}\n\n.earnings-bar-table tbody tr.odd {\n  background: var(--bg-gray);\n}\n\n.earnings-bar-table tbody tr:hover {\n  background: var(--bg-gray-light);\n}\n\n.earnings-bar-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.earnings-bar-totals-row {\n  background: var(--bg-gray-light) !important;\n  border-top: 2px solid var(--primary-red);\n  border-bottom: 2px solid var(--border-gray);\n  font-weight: 600;\n}\n\n.earnings-bar-totals-row td {\n  color: var(--text-white);\n  font-weight: 600;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.earnings-bar-totals-row td:first-child {\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--primary-red);\n}\n\n.earnings-bar-table td {\n  padding: 0.875rem 1.25rem;\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-right: 1px solid var(--border-gray);\n  white-space: nowrap;\n  text-align: left;\n}\n\n.earnings-bar-table td:last-child {\n  border-right: none;\n}\n\n.earnings-bar-table td.earnings-bar-num {\n  color: #22c55e;\n}\n\n/* # of shows column uses same white as bar names */\n.earnings-bar-table td.earnings-bar-show-count {\n  color: var(--text-white);\n}\n\n.earnings-bar-table td.earnings-bar-total {\n  font-weight: 700;\n  color: #22c55e;\n}\n\n.earnings-bar-breakdown-empty {\n  padding: 2rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 1rem;\n}\n\n.earnings-bar-breakdown-empty p {\n  margin: 0;\n}\n\n.earnings-table-section {\n  margin-top: 3rem;\n}\n\n.earnings-table-header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.earnings-table-header .section-title {\n  margin: 0;\n}\n\n.earnings-table-filter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.earnings-table-filter label {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.earnings-table-filter select {\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid var(--border-gray);\n  background: var(--bg-card);\n  color: var(--text-white);\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.earnings-table-filter select:focus {\n  outline: none;\n  border-color: var(--primary-red);\n}\n\n/* Excel-like Table Styles */\n.earnings-table-container {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  overflow: hidden;\n  margin-top: 1.5rem;\n}\n\n.earnings-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--bg-card);\n}\n\n.earnings-table thead {\n  background: var(--bg-gray);\n  border-bottom: 2px solid var(--border-gray);\n}\n\n.earnings-table th {\n  padding: 1rem 1.25rem;\n  text-align: left;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-right: 1px solid var(--border-gray);\n  white-space: nowrap;\n}\n\n.earnings-table th:last-child {\n  border-right: none;\n}\n\n.earnings-table tbody tr {\n  border-bottom: 1px solid var(--border-gray);\n  transition: background-color 0.2s ease;\n}\n\n.earnings-table tbody tr.even {\n  background: var(--bg-card);\n}\n\n.earnings-table tbody tr.odd {\n  background: var(--bg-gray);\n}\n\n.earnings-table tbody tr:hover {\n  background: var(--bg-gray-light);\n}\n\n.earnings-table tbody tr.earnings-table-row-clickable {\n  cursor: pointer;\n}\n\n.earnings-table tbody tr.earnings-table-row-clickable:hover {\n  background: var(--bg-gray-light);\n}\n\n.earnings-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.earnings-table-totals-row {\n  background: var(--bg-gray-light) !important;\n  border-top: 2px solid var(--primary-red);\n  border-bottom: 2px solid var(--border-gray);\n  font-weight: 600;\n}\n\n.earnings-table-totals-row td {\n  color: var(--text-white);\n  font-weight: 600;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.earnings-table-totals-row td:first-child {\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--primary-red);\n}\n\n.earnings-table td {\n  padding: 0.875rem 1.25rem;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  border-right: 1px solid var(--border-gray);\n  white-space: nowrap;\n}\n\n.earnings-table td:last-child {\n  border-right: none;\n}\n\n.earnings-table-empty {\n  padding: 3rem 2rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 1rem;\n}\n\n.earnings-table-empty p {\n  margin: 0;\n}\n\n/* Responsive Table */\n@media (max-width: 768px) {\n  .earnings-page-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .earnings-bar-section {\n    min-width: 0;\n  }\n\n  .earnings-bar-breakdown-container {\n    overflow-x: visible;\n    min-width: 0;\n  }\n\n  .earnings-table-header {\n    flex-direction: column;\n    align-items: stretch;\n    text-align: center;\n    gap: 0.75rem;\n  }\n\n  .earnings-table-filter {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .earnings-table-section {\n    min-width: 0;\n  }\n\n  .earnings-table-container {\n    overflow-x: visible;\n    min-width: 0;\n  }\n\n  /* Stacked “card” rows for earnings tables (avoids 6-column squeeze / overlap) */\n  .earnings-bar-table thead,\n  .earnings-table thead {\n    display: none;\n  }\n\n  .earnings-bar-table colgroup,\n  .earnings-table colgroup {\n    display: none;\n  }\n\n  .earnings-bar-table,\n  .earnings-table {\n    display: block;\n    width: 100%;\n    table-layout: auto;\n  }\n\n  .earnings-bar-table tbody,\n  .earnings-table tbody {\n    display: block;\n  }\n\n  .earnings-bar-table tbody tr,\n  .earnings-table tbody tr {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0.75rem;\n    padding: 0.75rem 1rem;\n    border: 1px solid var(--border-gray);\n    border-radius: 12px;\n    background: var(--bg-card);\n    box-sizing: border-box;\n  }\n\n  .earnings-bar-table tbody tr:last-child,\n  .earnings-table tbody tr:last-child {\n    margin-bottom: 0;\n  }\n\n  .earnings-bar-table tbody tr.even {\n    background: var(--bg-card);\n  }\n\n  .earnings-bar-table tbody tr.odd {\n    background: rgba(255, 255, 255, 0.03);\n  }\n\n  .earnings-bar-table tbody tr:hover,\n  .earnings-table tbody tr:hover {\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  .earnings-bar-totals-row,\n  .earnings-table-totals-row {\n    border: 2px solid var(--primary-red);\n    background: var(--bg-gray-light) !important;\n  }\n\n  .earnings-bar-table td,\n  .earnings-table td {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 0.75rem;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0.5rem 0;\n    border: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    white-space: normal;\n    text-align: right;\n    font-size: 0.9rem;\n  }\n\n  .earnings-bar-table td:last-child,\n  .earnings-table td:last-child {\n    border-bottom: none;\n  }\n\n  .earnings-bar-table td[data-label]::before,\n  .earnings-table td[data-label]::before {\n    content: attr(data-label);\n    flex-shrink: 0;\n    max-width: 48%;\n    font-weight: 600;\n    font-size: 0.75rem;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    text-align: left;\n    line-height: 1.3;\n  }\n\n  .earnings-bar-table td.earnings-bar-mobile-summary-heading,\n  .earnings-table td.earnings-table-mobile-summary-heading {\n    display: block;\n    text-align: left;\n    font-weight: 700;\n    font-size: 0.95rem;\n    color: var(--primary-red);\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    padding: 0 0 0.5rem 0;\n    margin-bottom: 0.25rem;\n    border-bottom: 2px solid var(--primary-red);\n  }\n\n  .earnings-table tbody tr.earnings-table-row-clickable {\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .earnings-table tbody tr.earnings-table-row-clickable:focus-visible {\n    outline: 2px solid var(--primary-red);\n    outline-offset: 2px;\n  }\n}\n\n/* Groups Page Styles */\n.groups-page {\n  padding: 2rem 1rem;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.groups-section {\n  margin-bottom: 4rem;\n}\n\n.groups-section:last-child {\n  margin-bottom: 0;\n}\n\n.groups-section .section-title {\n  color: var(--text-white);\n  font-size: 2rem;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 2rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.groups-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  min-height: 300px;\n}\n\n.groups-loading .spinner {\n  width: 3rem;\n  height: 3rem;\n  border: 3px solid var(--border-gray);\n  border-top-color: var(--primary-red);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 1rem;\n}\n\n.groups-loading p {\n  color: var(--text-gray);\n  font-size: 1rem;\n}\n\n.groups-error {\n  text-align: center;\n  padding: 2rem;\n  color: var(--primary-red);\n  background: rgba(250, 82, 82, 0.1);\n  border: 1px solid rgba(250, 82, 82, 0.3);\n  border-radius: 12px;\n}\n\n.groups-error p {\n  margin: 0;\n  font-size: 1rem;\n}\n\n/* Bars Grid - Similar to Artists Grid */\n.bars-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  padding-bottom: 2rem;\n}\n\n.bar-card {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.bar-card:hover {\n  transform: translateY(-4px);\n  border-color: var(--primary-red);\n  box-shadow: 0 8px 25px rgba(220, 38, 38, 0.2);\n}\n\n.bar-photo {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  background: var(--bg-gray-light);\n}\n\n.bar-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.bar-card:hover .bar-photo img {\n  transform: scale(1.05);\n}\n\n.bar-info {\n  padding: 1.5rem;\n}\n\n.bar-name {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-white);\n  margin-bottom: 0.5rem;\n}\n\n.bar-address {\n  color: var(--text-gray);\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n/* Bar Modal Styles */\n.bar-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 8, 10, 0.82);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(6px);\n  z-index: 1100;\n  padding: 1.5rem;\n}\n\n.bar-modal {\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  background: var(--bg-card);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n  overflow: hidden;\n  animation: showCardModalFade 0.25s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.bar-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.75rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: relative;\n}\n\n.bar-modal-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n}\n\n.bar-modal-header-content h2 {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--text-white);\n  letter-spacing: 0.5px;\n}\n\n.bar-modal-address {\n  margin: 0.4rem 0 0;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.95rem;\n  letter-spacing: 0.4px;\n}\n\n.bar-modal-close {\n  border: none;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.6);\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  font-size: 1.75rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.bar-modal-close:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--primary-red);\n}\n\n.bar-modal-body {\n  padding: 1.75rem;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* Bar Modal: match Edit modal section styling (onboarding-section) */\n.bar-modal-body .onboarding-section .section-title {\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.bar-modal-body .form-grid {\n  min-width: 0;\n}\n\n.bar-modal-body .form-grid .input-group {\n  min-width: 0;\n}\n\n.bar-modal-map-toggle {\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 6px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.bar-modal-map-toggle:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: var(--primary-red);\n  color: var(--text-white);\n}\n\n.bar-modal-leave-btn {\n  padding: 0.5rem 1rem;\n  background: rgba(255, 0, 51, 0.1);\n  border: 1px solid var(--primary-red);\n  border-radius: 6px;\n  color: var(--primary-red);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.bar-modal-leave-btn:hover:not(:disabled) {\n  background: rgba(255, 0, 51, 0.2);\n  border-color: var(--primary-red-glow);\n  color: var(--primary-red-glow);\n}\n\n.bar-modal-leave-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.bar-modal-artist-selector-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 8, 10, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  backdrop-filter: blur(4px);\n}\n\n.bar-modal-artist-selector {\n  background: var(--bg-card);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 2rem;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.bar-modal-artist-selector h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--text-white);\n}\n\n.bar-modal-artist-selector p {\n  margin: 0 0 1.5rem 0;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.95rem;\n}\n\n.bar-modal-artist-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.bar-modal-artist-option {\n  padding: 0.75rem 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.bar-modal-artist-option:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--primary-red);\n}\n\n.bar-modal-artist-selector-cancel {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.bar-modal-artist-selector-cancel:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--text-white);\n}\n\n.bar-modal-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.bar-modal-section-title {\n  color: var(--text-white);\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0;\n}\n\n.bar-modal-photos {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 1rem;\n}\n\n.bar-modal-photo {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 1px solid var(--border-gray);\n  transition: transform 0.3s ease;\n}\n\n.bar-modal-photo:hover {\n  transform: scale(1.05);\n  border-color: var(--primary-red);\n}\n\n.bar-modal-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.bar-modal-label {\n  display: block;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.bar-modal-value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.bar-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1.25rem 1.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  gap: 0.75rem;\n  background: transparent;\n}\n\n.bar-modal-close-btn {\n  border: none;\n  padding: 0.7rem 1.8rem;\n  border-radius: 999px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: box-shadow 0.2s ease, transform 0.2s ease,\n    background-color 0.2s ease;\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.bar-modal-close-btn:hover:enabled {\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);\n  transform: translateY(-1px);\n  background: rgba(255, 255, 255, 0.12);\n}\n\n/* Responsive Groups Page */\n@media (max-width: 768px) {\n  .groups-page {\n    padding: 1rem 0.5rem;\n  }\n\n  .groups-section .section-title {\n    font-size: 1.5rem;\n  }\n\n  .artists-grid,\n  .bars-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .bar-modal {\n    max-width: 95vw;\n    max-height: 95vh;\n  }\n\n  .bar-modal-photos {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Bulletin Board - Coming Soon */\n.bulletin-board-page {\n  padding: 2rem 1rem;\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.coming-soon-container {\n  text-align: center;\n  padding: 3rem 2rem;\n}\n\n.coming-soon-icon {\n  font-size: 3rem;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n.coming-soon-container h2 {\n  font-size: 1.75rem;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary, #fff);\n}\n\n.coming-soon-message {\n  color: var(--text-secondary, rgba(255, 255, 255, 0.7));\n  font-size: 1rem;\n}\n\n/* Genre multi-select (onboarding + artist modals) */\n.genre-multiselect {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.genre-multiselect-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  min-height: 1.5rem;\n}\n\n.genre-multiselect-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: var(--text-primary, #fff);\n}\n\n.genre-multiselect-chip-remove {\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.75);\n  cursor: pointer;\n  font-size: 1.1rem;\n  line-height: 1;\n  padding: 0 0.15rem;\n}\n\n.genre-multiselect-chip-remove:hover:not(:disabled) {\n  color: #fff;\n}\n\n.genre-multiselect-chip-remove:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.genre-multiselect-hint {\n  margin: 0;\n  font-size: 0.8rem;\n  opacity: 0.85;\n}\n\n/* Display-only genre pills (profile modals, cards) */\n.artist-genre-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.artist-genre-pill {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n/* Groups page: centered title + primary action without duplicate invisible buttons */\n.groups-page-header {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 2rem;\n}\n\n.groups-page-header__action {\n  grid-column: 1;\n  justify-self: start;\n}\n\n.groups-page-header__title {\n  grid-column: 2;\n  margin: 0;\n  text-align: center;\n}\n\n/* Artist month calendar — day-detail list (desktop + mobile) */\n.artist-day-detail-modal-content {\n  max-height: min(60vh, 28rem);\n  overflow-y: auto;\n}\n\n.artist-day-detail-empty {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 0.95rem;\n}\n\n.artist-day-detail-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.artist-day-detail-item {\n  margin: 0;\n}\n\n.artist-day-detail-show-row {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem 0.75rem;\n  text-align: left;\n  padding: 0.85rem 1rem;\n  border-radius: 12px;\n  border: 1px solid var(--border-gray);\n  background: var(--bg-gray);\n  color: var(--text-white);\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.artist-day-detail-show-row:hover {\n  border-color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.artist-day-detail-show-time {\n  font-weight: 600;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.artist-day-detail-show-venue {\n  flex: 1 1 100%;\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.artist-day-detail-pending {\n  margin-left: auto;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba(255, 210, 120, 1);\n}\n\n@media (max-width: 768px) {\n  /* Groups header: stack title above full-width button */\n  .groups-page-header {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n\n  .groups-page-header__title {\n    order: -1;\n    text-align: center;\n  }\n\n  .groups-page-header__action {\n    width: 100%;\n    justify-self: stretch;\n  }\n\n  /*\n   * Artist calendar nav (both week dashboard and full-month Calendar): compact column-stacked nav on mobile.\n   * Mirrors .bar-owner-dashboard calendar mobile behavior without affecting bar-owner desktop CSS files.\n   */\n  .artist-dashboard .calendar-section .calendar-nav {\n    gap: 1rem;\n    flex-direction: column;\n  }\n\n  .artist-dashboard .calendar-section .calendar-nav-content {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 0.65rem 0.75rem;\n  }\n\n  .artist-dashboard .calendar-section .calendar-month-display {\n    order: -1;\n    flex: 1 1 100%;\n    min-width: 0;\n    width: 100%;\n    letter-spacing: 0.12em;\n    margin: 0;\n    font-size: 1.15rem;\n    text-align: center;\n  }\n\n  .artist-dashboard .calendar-section .calendar-nav-content > .nav-btn-group {\n    flex: 1 1 0;\n    min-width: 0;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 0.35rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .artist-dashboard .calendar-section .calendar-nav-content .nav-btn {\n    padding: 0.55rem 0.45rem;\n    font-size: 0.72rem;\n    letter-spacing: 0.03em;\n    flex: 1 1 auto;\n    min-width: 0;\n    text-transform: uppercase;\n  }\n\n  .artist-dashboard .calendar-section .calendar-nav-content .nav-btn.month-btn {\n    flex: 1 1 auto;\n    padding: 0.55rem 0.85rem;\n    font-size: 0.78rem;\n  }\n\n  .artist-dashboard .month-calendar {\n    gap: 0.35rem;\n  }\n\n  .artist-dashboard .calendar-day-cell {\n    min-height: 3.35rem;\n    padding: 0.35rem 0.28rem;\n    justify-content: flex-start;\n    cursor: pointer;\n  }\n\n  .artist-dashboard .calendar-day-cell.other-month {\n    cursor: default;\n  }\n\n  .artist-dashboard .calendar-day-cell .day-header {\n    margin-bottom: 0;\n  }\n\n  .artist-dashboard .calendar-day-cell .day-number {\n    font-size: 0.85rem;\n  }\n\n  .artist-dashboard .calendar-day-cell .day-shows {\n    display: none;\n  }\n\n  .artist-dashboard .calendar-day-mobile-summary {\n    display: flex;\n    margin-top: 0.2rem;\n  }\n\n  .artist-dashboard .calendar-day-cell[role=\"button\"]:focus-visible {\n    outline: 2px solid var(--primary-red);\n    outline-offset: 2px;\n  }\n\n  .artist-dashboard .calendar-day-show-count {\n    font-size: 0.68rem;\n  }\n\n  /* Artist Calendar day-detail modal: mirror bar-owner mobile sizing & spacing.\n     Selectors target the modal's own classes since the modal is rendered outside\n     the .artist-dashboard wrapper in Calendar.js. */\n  /* Cap width only — modals-mobile.css pins .modal-container with left/right + width:auto;\n     a fixed width here fights that and can widen the scrollable document on mobile. */\n  .modal-container.calendar-day-detail-modal {\n    max-height: 80vh;\n    max-height: 80dvh;\n    max-width: min(640px, calc(100vw - max(24px, env(safe-area-inset-left) + env(safe-area-inset-right))));\n  }\n\n  .calendar-day-detail-modal .modal-content,\n  .calendar-day-detail-modal .artist-day-detail-modal-content {\n    margin: 0 auto;\n    width: 100%;\n    max-width: 640px;\n    align-items: center;\n    padding: 1.5rem;\n    gap: 1rem;\n  }\n\n  .calendar-day-detail-modal .artist-day-detail-list {\n    width: 100%;\n    max-width: 560px;\n  }\n\n  .calendar-day-detail-modal .artist-day-detail-show-row {\n    width: 100%;\n  }\n\n  /* Settings: avoid horizontal clip inside tab panels */\n  .artist-dashboard .tab-content {\n    min-width: 0;\n  }\n\n  /* Onboarding: comfortable horizontal padding on phones */\n  .onboarding-page .onboarding-container {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
